var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table-cell',{staticClass:"time",attrs:{"border":_vm.border}},_vm._l((_vm.slots),function(slot,index){return _c('div',{key:index,staticClass:"time-slot"},[_vm._v(_vm._s(slot.time))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }